export default "__VITE_ASSET__CKcj0GJ0__"